import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ede7ea0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "IDESideBar sidebar" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-folder-tree" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-cloud-arrow-down" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "bottom" }
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-clapperboard" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pause" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-gear" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

import { ref, withDefaults } from 'vue';

export interface PropsOptions {
	followLectorActivity: boolean,
	videoIsPlaying: boolean,
	selectedTab:string|null,
}


export const EmitsOptions = {
	'onFollowLectorActivityChanged' : (followLectorActivity: boolean) => {return true;},
	'update:selectedTab' : (selectedTab: string) => {return true;},
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IDESideBar',
  props: {
    followLectorActivity: { type: Boolean, default() {
		return true;
	} },
    videoIsPlaying: { type: Boolean, default() {
		return false;
	} },
    selectedTab: { default() {
		return null;
	} }
  },
  emits: EmitsOptions,
  setup(__props: any, { emit }) {

const props = __props as { followLectorActivity: boolean, videoIsPlaying: boolean, selectedTab:string|null }




function onFollowLectorActivityChanged() {
	// zapnout pokud je video pauznute nebo je vypnute sledovani aktivity lektora
	const followLectorActivity = !props.videoIsPlaying || !props.followLectorActivity;
	emit('onFollowLectorActivityChanged', followLectorActivity);
}

function onSelectTab(newSelectedTab:string) {
	emit('update:selectedTab', newSelectedTab);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item fileSystem", {selected: __props.selectedTab == 'fileSystem'}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onSelectTab('fileSystem')))
      }, _hoisted_4, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item download", {selected: __props.selectedTab == 'download'}]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onSelectTab('download')))
      }, _hoisted_6, 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "menu-item follow-lector",
        title: __props.followLectorActivity && __props.videoIsPlaying ? 'Zapnuté sledování aktivity lektora' : (!__props.videoIsPlaying ? 'Video je pozastavené' : 'Sledování aktivity lektora dočasně vypnuto')
      }, [
        _createElementVNode("label", {
          class: "toggler-wrapper",
          onClick: onFollowLectorActivityChanged
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["toggler-slider", {active: __props.followLectorActivity && __props.videoIsPlaying}])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["toggler-knob", {semiSwitchedOn: __props.videoIsPlaying, fullySwitchedOn: __props.videoIsPlaying && __props.followLectorActivity}])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["icon", {shown: __props.videoIsPlaying}])
              }, _hoisted_10, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["icon off", {shown: !__props.videoIsPlaying}])
              }, _hoisted_12, 2)
            ], 2)
          ], 2)
        ])
      ], 8, _hoisted_8),
      _createElementVNode("div", {
        class: _normalizeClass(["menu-item settings", {selected: __props.selectedTab == 'settings'}]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (onSelectTab('settings')))
      }, _hoisted_14, 2)
    ])
  ]))
}
}

})